AFRAME.registerComponent('news-graph-settings-panel', {
    init: function () {
        this.render = this.render.bind(this);
        this.updateRotationLabel = this.updateRotationLabel.bind(this);
        this.updateViewModeBlock = this.updateViewModeBlock.bind(this);
        this._currentViewMode = '3d';
        this.render();

        this.el.sceneEl.addEventListener('news-graph-autorotate-changed', this.updateRotationLabel);
        this.el.sceneEl.addEventListener('theme-changed', this.render);
        this.el.sceneEl.addEventListener('news-graph-view-mode-changed', this.updateViewModeBlock);
    },

    remove: function () {
        this.el.sceneEl.removeEventListener('news-graph-autorotate-changed', this.updateRotationLabel);
        this.el.sceneEl.removeEventListener('theme-changed', this.render);
        this.el.sceneEl.removeEventListener('news-graph-view-mode-changed', this.updateViewModeBlock);
    },

    _isLightMode: function() {
        if (typeof getCacheItem === 'function') {
            const settings = getCacheItem('mainSettings');
            if (settings && settings.themeMode) {
                return settings.themeMode === 'Light';
            }
        }
        return false;
    },

    updateRotationLabel: function () {
        if (!this.rotateBtn) return;
        const wrapper = document.getElementById('news-graph-wrapper');
        const rotationComp = wrapper && wrapper.components['news-graph-rotation'];
        const autoRotateEnabled = rotationComp && typeof rotationComp.isAutoRotateEnabled === 'function'
            ? rotationComp.isAutoRotateEnabled()
            : true;

        this.rotateBtn.setAttribute('ui-button', 'label', autoRotateEnabled ? 'Stop Rotation' : 'Start Rotation');
        this.rotateBtn.setAttribute('ui-button', 'colorScheme', autoRotateEnabled ? 'accent' : 'primary');
    },

    updateViewModeBlock: function (evt) {
        const mode = (evt && evt.detail && evt.detail.mode) ? evt.detail.mode : '3d';
        this._currentViewMode = mode;
        this.render();
    },

    _createViewModeBlock: function (currentMode) {
        const isLight      = this._isLightMode();
        const txtColor     = isLight ? '#14141C' : '#FFFFFF';
        const selectColor  = isLight ? '#3636E3' : '#FFFFFF';
        const blockWidth   = 0.30;
        const halfWidth    = blockWidth / 2;
        const rowHeight    = 0.05;

        const container = document.createElement('a-entity');
        container.setAttribute('id', 'ng-settings-view-mode-block');
        container.setAttribute('position', `0 -0.06 0.01`);

        const label = document.createElement('a-troika-text');
        label.setAttribute('value', 'View');
        label.setAttribute('font-size', 0.024);
        label.setAttribute('color', txtColor);
        label.setAttribute('align', 'right');
        label.setAttribute('anchor', 'right');
        label.setAttribute('position', `-0.18 0 0.005`);
        container.appendChild(label);

        const bg = document.createElement('a-rounded-plane');
        bg.setAttribute('height', rowHeight);
        bg.setAttribute('width', blockWidth);
        bg.setAttribute('radius', '0.01');
        bg.setAttribute('color', isLight ? '#1e1e1e' : '#fff');
        bg.setAttribute('opacity', '0.08');
        bg.setAttribute('position', `${-halfWidth} ${-rowHeight / 2} 0.002`);
        container.appendChild(bg);

        const selectPlane = document.createElement('a-rounded-plane');
        selectPlane.setAttribute('height', rowHeight);
        selectPlane.setAttribute('width', halfWidth);
        selectPlane.setAttribute('radius', '0.01');
        selectPlane.setAttribute('color', selectColor);
        const activeX = currentMode === '3d' ? -halfWidth : 0;
        selectPlane.setAttribute('position', `${activeX} ${-rowHeight / 2} 0.003`);
        container.appendChild(selectPlane);

        const is3dActive = currentMode === '3d';
        let color3d, color2d;
        if (isLight) {
            color3d = is3dActive  ? '#FFFFFF' : '#14141C';
            color2d = !is3dActive ? '#FFFFFF' : '#14141C';
        } else {
            color3d = is3dActive  ? '#14141C' : '#FFFFFF';
            color2d = !is3dActive ? '#14141C' : '#FFFFFF';
        }

        const text3d = document.createElement('a-troika-text');
        text3d.setAttribute('value', '3D');
        text3d.setAttribute('color', color3d);
        text3d.setAttribute('font-size', 0.022);
        text3d.setAttribute('anchor', 'center');
        text3d.setAttribute('position', `${-halfWidth / 2} 0 0.004`);
        container.appendChild(text3d);

        const text2d = document.createElement('a-troika-text');
        text2d.setAttribute('value', '2D');
        text2d.setAttribute('color', color2d);
        text2d.setAttribute('font-size', 0.022);
        text2d.setAttribute('anchor', 'center');
        text2d.setAttribute('position', `${halfWidth / 2} 0 0.004`);
        container.appendChild(text2d);

        const btn3d = document.createElement('a-plane');
        btn3d.setAttribute('height', rowHeight);
        btn3d.setAttribute('width', halfWidth);
        btn3d.setAttribute('opacity', '0');
        btn3d.setAttribute('data-raycastable', '');
        btn3d.setAttribute('position', `${-halfWidth / 2} 0 0.005`);
        btn3d.addEventListener('click', () => {
            this.el.sceneEl.emit('news-graph-toggle-view-mode', { mode: '3d' });
            if (window.gtag) gtag('event', 'VR_NewsGraphSettings_Switch3D');
        });
        container.appendChild(btn3d);

        const btn2d = document.createElement('a-plane');
        btn2d.setAttribute('height', rowHeight);
        btn2d.setAttribute('width', halfWidth);
        btn2d.setAttribute('opacity', '0');
        btn2d.setAttribute('data-raycastable', '');
        btn2d.setAttribute('position', `${halfWidth / 2} 0 0.005`);
        btn2d.addEventListener('click', () => {
            this.el.sceneEl.emit('news-graph-toggle-view-mode', { mode: '2d' });
            if (window.gtag) gtag('event', 'VR_NewsGraphSettings_Switch2D');
        });
        container.appendChild(btn2d);

        return container;
    },

    createToggle: function (id, x, label, isActive, onToggle) {
        const isLight = this._isLightMode();
        const textColor = isLight ? '#111827' : '#ffffff';
        const capsuleColor = isLight ? '#000000' : '#ffffff';
        const activeColor = isLight ? '#3636E3' : '#ffffff';
        const inactiveColor = isLight ? '#737373' : '#4f4f4f';

        const container = document.createElement('a-entity');
        container.setAttribute('id', id);
        container.setAttribute('position', `${x} 0.05 0.01`);

        const text = document.createElement('a-troika-text');
        text.setAttribute('value', label);
        text.setAttribute('font-size', 0.035);
        text.setAttribute('color', textColor);
        text.setAttribute('align', 'left');
        text.setAttribute('anchor', 'left');
        text.setAttribute('position', '-0.13 0 0.005');
        container.appendChild(text);

        const toggleBg = document.createElement('a-rounded-plane');
        toggleBg.setAttribute('position', '0.03 -0.01 0.005');
        toggleBg.setAttribute('color', capsuleColor);
        toggleBg.setAttribute('opacity', 0.15);
        toggleBg.setAttribute('height', 0.03);
        toggleBg.setAttribute('width', 0.08);
        toggleBg.setAttribute('radius', 0.008);
        container.appendChild(toggleBg);

        const knob = document.createElement('a-rounded-plane');
        knob.setAttribute('position', `${isActive ? 0.07 : 0.03} -0.015 0.01`);
        knob.setAttribute('width', 0.04);
        knob.setAttribute('height', 0.04);
        knob.setAttribute('radius', 0.004);
        knob.setAttribute('color', isActive ? activeColor : inactiveColor);
        container.appendChild(knob);

        const clickArea = document.createElement('a-plane');
        clickArea.setAttribute('width', 0.32);
        clickArea.setAttribute('height', 0.12);
        clickArea.setAttribute('opacity', 0);
        clickArea.setAttribute('data-raycastable', '');
        clickArea.setAttribute('position', '0 0 0.015');
        clickArea.addEventListener('click', () => {
            isActive = !isActive;
            knob.setAttribute('position', `${isActive ? 0.07 : 0.03} -0.015 0.01`);
            knob.setAttribute('color', isActive ? activeColor : inactiveColor);
            onToggle(isActive);
        });
        container.appendChild(clickArea);

        return { container, clickArea };
    },

    render: function () {
        this.el.innerHTML = '';
        this._viewModeContainer = null;

        const isLight = this._isLightMode();
        const panelColor = isLight ? '#F5F5F5' : '#111';

        const bg = document.createElement('a-rounded-plane');
        bg.setAttribute('width', 1.15);
        bg.setAttribute('height', 0.28);
        bg.setAttribute('position', '-0.575 -0.14 0');
        bg.setAttribute('color', panelColor);
        bg.setAttribute('opacity', 1.0);
        bg.setAttribute('radius', 0.025);
        this.el.appendChild(bg);

        const rotateBtn = this.rotateBtn = document.createElement('a-entity');
        rotateBtn.setAttribute('id', 'ng-settings-rotate-btn');
        rotateBtn.setAttribute('data-raycastable', '');
        rotateBtn.setAttribute('position', '-0.35 0.05 0.01');
        rotateBtn.setAttribute('ui-button', {
            label: 'Start Rotation',
            width: 0.32,
            height: 0.11,
            depth: 0.015,
            radius: 0.015,
            colorScheme: 'primary',
            type: 'rounded-box',
            preferredFontSize: 0.033
        });
        rotateBtn.addEventListener('click', () => {
            this.el.sceneEl.emit('news-graph-toggle-autorotate');
            if (window.gtag) gtag('event', 'VR_NewsGraphSettings_ToggleRotate');
        });
        this.el.appendChild(rotateBtn);

        let isLegendVisible = true;
        const legendPanel = document.getElementById('news-graph-legend-vr');
        if (legendPanel) {
            isLegendVisible = legendPanel.getAttribute('visible') !== false && legendPanel.getAttribute('visible') !== 'false';
        }
        const legendToggle = this.createToggle('ng-settings-legend-toggle', 0.01, 'Legend', isLegendVisible, (visible) => {
            const panel = document.getElementById('news-graph-legend-vr');
            if (panel) {
                panel.setAttribute('visible', visible);
            }
            if (window.gtag) gtag('event', 'VR_NewsGraphSettings_ToggleLegend', { visible });
        });
        this.el.appendChild(legendToggle.container);

        let isGlobeVisible = true;
        try {
            const configControlEl = document.querySelector('#configure-control');
            const configControl = configControlEl && configControlEl.components['configure-control'];
            if (configControl && typeof configControl.data.isGlobeVisible !== 'undefined') {
                isGlobeVisible = !!configControl.data.isGlobeVisible;
            } else {
                const settings = (typeof getCacheItem === 'function') ? getCacheItem('configureControlSettings') : null;
                const actualSettings = settings ? (settings.value || settings) : null;
                if (actualSettings && typeof actualSettings.isGlobeVisible !== 'undefined') {
                    isGlobeVisible = !!actualSettings.isGlobeVisible;
                } else {
                    const newsGraphEl = document.querySelector('[news-graph-vr], [news-graph-2d-vr]');
                    const newsGraphComp = newsGraphEl && (newsGraphEl.components['news-graph-vr'] || newsGraphEl.components['news-graph-2d-vr']);
                    if (newsGraphComp && newsGraphComp.orbitSphere) {
                        isGlobeVisible = newsGraphComp.orbitSphere.visible !== false;
                    }
                }
            }
        } catch (e) {
            console.warn('Failed to load globe visibility setting in VR:', e);
        }

        const boundaryLabel = this._currentViewMode === '2d' ? 'Ring' : 'Globe';
        const globeToggle = this.createToggle('ng-settings-globe-toggle', 0.37, boundaryLabel, isGlobeVisible, (visible) => {
            this.el.sceneEl.emit('news-graph-set-globe-visible', { visible });
            try {
                const configControlEl = document.querySelector('#configure-control');
                if (configControlEl && configControlEl.components['configure-control']) {
                    configControlEl.setAttribute('configure-control', 'isGlobeVisible', visible);
                } else {
                    const STORAGE_KEY = 'configureControlSettings';
                    const EXPIRATION_TIME = typeof CACHE_EXPIRATION !== 'undefined' ? CACHE_EXPIRATION.PERSISTENT : 5256000;
                    let payload = {};
                    if (typeof getCacheItem === 'function') {
                        const existing = getCacheItem(STORAGE_KEY);
                        payload = existing ? (existing.value || existing) : {};
                    }
                    payload.isGlobeVisible = visible;
                    if (typeof setCacheItem === 'function') {
                        setCacheItem(STORAGE_KEY, payload, EXPIRATION_TIME);
                    }
                    if (typeof protectKey === 'function') {
                        protectKey(STORAGE_KEY);
                    }
                }
            } catch (e) {
                console.warn('Failed to save globe visibility setting in VR:', e);
            }
            if (window.gtag) gtag('event', 'VR_NewsGraphSettings_ToggleGlobe', { visible });
        });

        let tooltipEl = null;
        globeToggle.clickArea.addEventListener('mouseenter', () => {
            if (tooltipEl) return;
            tooltipEl = document.createElement('a-entity');
            tooltipEl.setAttribute('position', '0.37 0.11 0.02');
            
            const tooltipBg = document.createElement('a-rounded-plane');
            tooltipBg.setAttribute('width', 0.52);
            tooltipBg.setAttribute('height', 0.06);
            tooltipBg.setAttribute('radius', 0.01);
            tooltipBg.setAttribute('color', '#222');
            tooltipBg.setAttribute('opacity', 0.9);
            tooltipEl.appendChild(tooltipBg);

            const tooltipText = document.createElement('a-troika-text');
            tooltipText.setAttribute(
                'value',
                this._currentViewMode === '2d'
                    ? 'Show ring between narratives and tickers'
                    : 'Show border between narratives and tickers'
            );
            tooltipText.setAttribute('font-size', 0.020);
            tooltipText.setAttribute('align', 'center');
            tooltipText.setAttribute('anchor', 'center');
            tooltipText.setAttribute('color', '#ffffff');
            tooltipText.setAttribute('position', '0.26 0.03 0.005');
            tooltipBg.appendChild(tooltipText);

            this.el.appendChild(tooltipEl);
        });

        globeToggle.clickArea.addEventListener('mouseleave', () => {
            if (tooltipEl) {
                tooltipEl.remove();
                tooltipEl = null;
            }
        });

        this.el.appendChild(globeToggle.container);

        const viewBlock = this._createViewModeBlock(this._currentViewMode);
        this.el.appendChild(viewBlock);
        this._viewModeContainer = viewBlock;

        setTimeout(this.updateRotationLabel, 50);
    }
});

export function mountSettingsPanel() {
    let settingsPanel = document.getElementById('news-graph-settings-panel');
    if (!settingsPanel) {
        settingsPanel = document.createElement('a-entity');
        settingsPanel.setAttribute('id', 'news-graph-settings-panel');
        settingsPanel.setAttribute('news-graph-settings-panel', '');
        
        settingsPanel.setAttribute('position', '-0.010 1.06 -1.40');
        settingsPanel.setAttribute('rotation', '0 0 0');
        settingsPanel.setAttribute('scale', '1.05 1.05 1.05');
        
        const sceneWrapper = document.getElementById('scene-wrapper');
        if (sceneWrapper) {
            sceneWrapper.appendChild(settingsPanel);
        } else {
            const scene = document.querySelector('a-scene');
            if (scene) scene.appendChild(settingsPanel);
        }
    }
}

export function unmountSettingsPanel() {
    const settingsPanel = document.getElementById('news-graph-settings-panel');
    if (settingsPanel) {
        settingsPanel.remove();
    }
}
